(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Announcement Bar Close Functionality
  function closeAnnouncementBar() {
    const announcementBar = document.getElementById('announcement-bar');
    if (announcementBar) {
      announcementBar.style.transform = 'translateY(-100%)';
      announcementBar.style.opacity = '0';
      setTimeout(() => {
        announcementBar.style.display = 'none';
      }, 300);
      localStorage.setItem('bricknest_announcement_closed', 'true');
    }
  }

  // Mobile Navigation Drawer Functions
  function openMobileNavDrawer() {
    console.log('Opening mobile nav drawer');
    const drawer = document.getElementById('mobile-nav-drawer');
    const overlay = document.getElementById('mobile-nav-overlay');
    
    if (drawer && overlay) {
      drawer.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      console.log('Drawer should now be open');
    } else {
      console.error('Could not find drawer or overlay elements');
    }
  }

  function closeMobileNavDrawer() {
    console.log('Closing mobile nav drawer');
    const drawer = document.getElementById('mobile-nav-drawer');
    const overlay = document.getElementById('mobile-nav-overlay');
    if (drawer && overlay) {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  // Alternative function in case the onclick doesn't work
  function initMobileNavDrawer() {
    const button = document.querySelector('.mobile-nav-drawer-btn');
    const overlay = document.getElementById('mobile-nav-overlay');
    const closeBtn = document.querySelector('.mobile-nav-close');
    
    if (button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Button clicked!');
        openMobileNavDrawer();
      });
    }
    
    if (overlay) {
      overlay.addEventListener('click', closeMobileNavDrawer);
    }
    
    if (closeBtn) {
      closeBtn.addEventListener('click', closeMobileNavDrawer);
    }

    // Initialize mobile submenu toggles
    const submenuButtons = document.querySelectorAll('.mobile-nav-link[data-has-submenu="true"]');
    console.log('Found submenu buttons:', submenuButtons.length);
    
    submenuButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Submenu button clicked:', this);
        toggleMobileSubmenu(this);
      });
      
      button.addEventListener('touchstart', function(e) {
        console.log('Submenu button touched:', this);
      });
    });
  }

  // Mobile submenu toggle function - Enhanced version
  function toggleMobileSubmenu(element) {
    console.log('Toggle submenu clicked', element);
    
    const parentItem = element.closest('.mobile-nav-item');
    console.log('Parent item found:', parentItem);
    
    if (!parentItem) {
      console.error('Could not find parent mobile-nav-item');
      return;
    }
    
    const isExpanded = parentItem.classList.contains('expanded');
    console.log('Is currently expanded:', isExpanded);
    
    // Close all other expanded items first
    const allExpandedItems = document.querySelectorAll('.mobile-nav-item.expanded');
    allExpandedItems.forEach(item => {
      if (item !== parentItem) {
        item.classList.remove('expanded');
        const button = item.querySelector('.mobile-nav-link[data-has-submenu="true"]');
        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
        console.log('Closed other expanded item');
      }
    });
    
    // Toggle current item
    if (isExpanded) {
      parentItem.classList.remove('expanded');
      element.setAttribute('aria-expanded', 'false');
      console.log('Collapsed current item');
    } else {
      parentItem.classList.add('expanded');
      element.setAttribute('aria-expanded', 'true');
      console.log('Expanded current item');
    }
    
    // Force a small delay and try again if it didn't work
    setTimeout(() => {
      const checkExpanded = parentItem.classList.contains('expanded');
      console.log('After timeout - is expanded:', checkExpanded);
      if (!isExpanded && !checkExpanded) {
        console.log('Forcing expansion...');
        parentItem.classList.add('expanded');
        element.setAttribute('aria-expanded', 'true');
      }
    }, 50);
  }

  // Backup function - simpler version
  window.toggleSubmenu = function(button) {
    console.log('Backup toggle function called');
    const item = button.parentElement;
    if (item.classList.contains('expanded')) {
      item.classList.remove('expanded');
    } else {
      // Close others
      document.querySelectorAll('.mobile-nav-item.expanded').forEach(el => {
        el.classList.remove('expanded');
      });
      // Open this one
      item.classList.add('expanded');
    }
  }

  // Check if announcement should be shown
  document.addEventListener('DOMContentLoaded', function() {
    const announcementBar = document.getElementById('announcement-bar');
    if (announcementBar && localStorage.getItem('bricknest_announcement_closed') === 'true') {
      announcementBar.style.display = 'none';
    }

    // Initialize mobile navigation drawer
    initMobileNavDrawer();

    // Close mobile nav drawer when pressing escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeMobileNavDrawer();
      }
    });

    // Enhanced mega menu functionality (desktop only)
    const navItems = document.querySelectorAll('.navigation-item');
    navItems.forEach(item => {
      const megaMenu = item.querySelector('.mega-menu');
      if (megaMenu) {
        let timeout;
        
        item.addEventListener('mouseenter', () => {
          clearTimeout(timeout);
          megaMenu.style.opacity = '1';
          megaMenu.style.visibility = 'visible';
          megaMenu.style.transform = 'translateX(-50%) translateY(0)';
        });
        
        item.addEventListener('mouseleave', () => {
          timeout = setTimeout(() => {
            megaMenu.style.opacity = '0';
            megaMenu.style.visibility = 'hidden';
            megaMenu.style.transform = 'translateX(-50%) translateY(-10px)';
          }, 150);
        });
      }
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      // Close original Shopify drawer menu
      const drawerMenu = document.querySelector('header-drawer');
      if (drawerMenu) {
        const details = drawerMenu.querySelector('details[open]');
        if (details) {
          details.removeAttribute('open');
        }
      }
      
      // Close mobile nav drawer
      closeMobileNavDrawer();
      
      // Close mega menus
      const megaMenus = document.querySelectorAll('.mega-menu');
      megaMenus.forEach(menu => {
        menu.style.opacity = '0';
        menu.style.visibility = 'hidden';
      });
    }

    closeSearchModal() {
      // Close any open search modals if needed
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
